import axios from "axios";

const DICTIONARIES_URL = import.meta.env.VITE_DICTIONARIES_URL;

export const GetCountryListService = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const countryList = await axios.get(
        `${DICTIONARIES_URL}/v1/country/getCountryList`
      );
      resolve(countryList.data);
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};
